import {
  REQUEST_CACHE_REFRESH,
  RECEIVE_CACHE_REFRESH,
  ERROR,
  CLEAR_ERROR
} from "./constants";
import api from "./api";
import { registerError } from "redux/modules/errors/actions";
import { eventId } from "redux/modules/event/selectors";
import { showSnackbar } from "redux/modules/snackbar/actions";

export function refreshCache() {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: REQUEST_CACHE_REFRESH });

      const state = getState();
      const currentEventId = eventId(state);

      const response = await api.refreshCache(
        state.user.user.credentials,
        currentEventId
      );

      dispatch({ type: RECEIVE_CACHE_REFRESH });
      // Show success message
      dispatch(
        showSnackbar({
          message: response.payload.message || "Cache refreshed successfully",
          type: "success"
        })
      );
    } catch (error) {
      dispatch({
        type: ERROR,
        payload: { error: error.error || "An error occurred!" }
      });
      dispatch(
        registerError([
          {
            system: error,
            user: "An error occurred refreshing cache"
          }
        ])
      );
      // Show error message
      dispatch(
        showSnackbar({
          message: error.error || "An error occurred refreshing cache",
          type: "error"
        })
      );
    }
  };
}

export function clearError() {
  return {
    type: CLEAR_ERROR
  };
}
